<template>
  <div id="set-page">
    <lang class="lang-box" />

    <div class="set-password">

      <set-password-header v-if="setState" />

      <div class="form-box" v-if="setState">
        <component :is="currentView[state]" :email="email"  @next="handleNext" />
      </div>

      <set-password-finish v-else/>

    </div>

  </div>

</template>

<script>
import SetPasswordHeader from "../components/set-password-header/SetPasswordHeader";
import SetPasswordFinish from "../components/set-password-finish/SetPasswordFinish";
import SetPasswordForm from "../components/set-password-form/SetPasswordForm";
import VerifyEmailCodeForm from "../components/verify-email-code-form/VerifyEmailCodeForm";
import VerifyEmailForm from "../components/verify-email-form/VerifyEmailForm";
import lang from "../components/lang/lang";

export default {
  name: "SetPassword",
  components: {SetPasswordForm, VerifyEmailCodeForm, VerifyEmailForm, SetPasswordFinish, SetPasswordHeader, lang},
  data() {
    return {
      api: {
        captcha: this.$api.email.captcha,
        verify: this.$api.email.verify,
        setPassword: this.$api.email.setPassword,
        updatePassword: this.$api.email.updatePassword,
      },
      state: 0, // 0 输入邮箱地址 1 获取邮箱验证码 2 设置密码 3 完成
      setState: true,
      currentView: {
        '0': 'VerifyEmailForm',
        '1': 'VerifyEmailCodeForm',
        '2': 'SetPasswordForm',
      },
      email: '',
    }
  },
  methods: {
    handleNext(e) {
      console.log('e', e)
      switch (this.state) {
        case 0 :
          this.handleGetEmailCaptcha(e);
          break;
        case 1 :
          this.handleVerifyCode(e);
          break;
        case 2 :
          this.handleSetPassword(e);
          break;
      }
    },

    // 发送验证码
    handleGetEmailCaptcha(data) {
      const vm  = this;
      vm.$http.post(vm.api.captcha, vm.$qs.stringify(data)).then(res => {
        if(res.data.status != 200) {
          vm.$message.error(this.$t(`lang.` + res.data.desc));
          return;
        }
        vm.state ++;
        this.email = data.email;
      }).catch(err => {
        console.log('获取失败', err);
      })
    },

    // 设置密码
    handleSetPassword(e) {
      const vm = this;
      const data = {
        account: vm.email,
        password: vm.$md5(e.rePassword)
      }
      vm.$http.post(vm.api.setPassword, vm.$qs.stringify(data)).then(res => {
        if(res.data.status != 200) {
          vm.$message.error(this.$t('lang.' + res.data.desc));
          return;
        }
        vm.setState = false;
      }).catch(err => {
        console.log('获取失败', err);
      })
    },

    // 验证邮箱
    handleVerifyCode(data) {
      const vm = this;
      data['email'] = vm.email;
      vm.$http.post(vm.api.verify, vm.$qs.stringify(data)).then(res => {
        if(res.data.status != 200) {
          vm.$message.error(this.$t('lang.' + res.data.desc));
          return;
        }
        vm.state ++;
      }).catch(err => {
        console.log('获取失败', err);
      })
    },

  }
}
</script>

<style lang="scss" scoped>

#set-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-image: url("../assets/login-bg.png");
  background-position: center;
  background-size: 100%;

  .set-password {
    width: 800px;
    height: 400px;
    background: #ffffff;
    border-radius: 10px;
    margin: 0 auto;
    padding: 24px;
    display: flex;
    flex-direction: column;
  }


  .form-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

  }
}

.lang-box {
  position: absolute;
  right: 44px;
  top: 24px;
  border: 1px solid #ddd;
  padding: 8px 24px;
  text-align: center;
}

</style>
